<!-- <div class="header-label">Invoices</div> -->
<div class="flex-fill d-flex dx-card">
  @if (!showAsComponent) {
    <div class="d-flex flex-fill flex-column col-sm-6">
      <div class="d-flex flex-column flex-fill p-2">
        <h4>Residential / Commercial Delivery</h4>
        <dx-data-grid
          #residentialJobsGrid
          [keyExpr]="'id'"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="residentialJobs"
          [showBorders]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowDblClick)="onResidentialRowDoubleClick($event)"
          [columnAutoWidth]="true"
          >
          <dxi-data-grid-column dataField="jobIdDisplay" caption="Job" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="rentalIdDisplay" caption="Rental" width="75" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="customer" caption="Customer" width="150" cellTemplate="customerLinkTemplate"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="completed" dataType="date" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="dumpster" caption="Dumpster" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="revenue" caption="Est. Rev" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="reason" caption="Type" width="125"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="serviceAddress.displayAddress" caption="Site"></dxi-data-grid-column>
          <div *dxTemplate="let cell of 'rentalLinkTemplate'">
            @if (cell && isInvoiceAdmin) {
              <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
            }
            @if (cell && !isInvoiceAdmin) {
              <div [innerHtml]="cell.text"></div>
            }
          </div>
          <div *dxTemplate="let cell of 'customerLinkTemplate'">
            @if (cell && isInvoiceAdmin) {
              <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
            }
            @if (cell && !isInvoiceAdmin) {
              <div [innerHtml]="cell.text"></div>
            }
          </div>
          <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="invoice-residential-rentals-grid"></dxo-data-grid-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button
              class="btn btn-sm btn-success me-1 mb-2"
              (click)="createInvoice(residentialJobsGrid.instance.getSelectedRowsData()[0].rentalId)"
              [disabled]="residentialJobsGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isInvoiceAdmin"
              >
              Create Invoice
            </button>
            <button
              class="btn btn-sm btn-danger me-1 mb-2"
              (click)="createRevenueLines(residentialJobsGrid.instance.getSelectedRowsData()[0].rentalId)"
              [disabled]="residentialJobsGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isInvoiceAdmin"
              >
              Create Revenue Lines
            </button>
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (residentialJobs) {
              <span class="me-3">
                <strong>{{ residentialJobsGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
      <div class="d-flex flex-column flex-fill p-2">
        <h4>Commercial</h4>
        <div class="d-flex flex-column flex-fill p-1">
          <dx-data-grid
            #commercialJobsGrid
            [keyExpr]="'id'"
            class="flex-fill d-flex flex-column"
            height="100px"
            [dataSource]="rentals"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="onRentalRowDoubleClick($event)"
            (onRowPrepared)="onRowPrepared($event)"
            [columnAutoWidth]="false"
            >
            <!-- <dxi-column dataField="id" caption="Id" width="75"></dxi-column> -->
            <dxi-data-grid-column dataField="rentalId" caption="Rental" width="75" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="customer" caption="Customer" width="200" cellTemplate="customerLinkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="dumpster" caption="Dumpster" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="jobCount" caption="# Jobs" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="dumpstersOnSite" caption="OnSite" width="70"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="completed" width="90" dataType="date"></dxi-data-grid-column>
            <dxi-data-grid-column
              dataField="revenue"
              caption="Est. Rev"
              [format]="{ type: 'currency', precision: 2 }"
              width="100"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="serviceAddress.displayAddress" caption="Site"></dxi-data-grid-column>
            <div *dxTemplate="let cell of 'rentalLinkTemplate'">
              @if (cell && isInvoiceAdmin) {
                <a [routerLink]="'/rentals/' + cell.data.id" [innerHtml]="cell.text"></a>
              }
              @if (cell && !isInvoiceAdmin) {
                <div [innerHtml]="cell.text"></div>
              }
            </div>
            <div *dxTemplate="let cell of 'customerLinkTemplate'">
              @if (cell && isInvoiceAdmin) {
                <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
              }
              @if (cell && !isInvoiceAdmin) {
                <div [innerHtml]="cell.text"></div>
              }
            </div>
            <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
            <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
            <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
            <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="invoice-rentals-grid"></dxo-data-grid-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'">
              <button
                class="btn btn-sm btn-success me-1 mb-2"
                (click)="createInvoice(commercialJobsGrid.instance.getSelectedRowsData()[0].id)"
                [disabled]="commercialJobsGrid.instance.getSelectedRowsData().length !== 1"
                [hidden]="!isInvoiceAdmin"
                >
                Create Invoice
              </button>
              <button
                class="btn btn-sm btn-danger me-1 mb-2"
                (click)="createRevenueLines(commercialJobsGrid.instance.getSelectedRowsData()[0].id)"
                [disabled]="commercialJobsGrid.instance.getSelectedRowsData().length !== 1"
                [hidden]="!isInvoiceAdmin"
                >
                Create Revenue Lines
              </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
              @if (rentals) {
                <span class="me-3">
                  <strong>{{ commercialJobsGrid.instance.totalCount() + ' items' }}</strong>
                </span>
              }
            </div>
          </dx-data-grid>
        </div>
      </div>
    </div>
  }

  <!-- Invoice Overview List -->
  <div [class]="(showAsComponent ? '' : '  col-sm-6 ') + ' d-flex flex-column flex-fill p-2'">
    @if (!showAsComponent) {
      <h4>Invoices</h4>
    }
    <div class="d-flex flex-column flex-fill p-1">
      <dx-data-grid
        #overviewGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="650px"
        [dataSource]="invoices"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="onRowDoubleClick($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column width="55" cellTemplate="iconTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="id" caption="Id" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceNumber" caption="Invoice #" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalIdDisplay" caption="Rental" width="75" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="status.name" caption="Status" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceDate" caption="Date" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="customer.displayName"
          caption="Customer"
          width="175"
          cellTemplate="customerLinkTemplate"
        ></dxi-data-grid-column>
        <dxi-data-grid-column dataField="sent" format="shortDate" caption="Sent" width="150"></dxi-data-grid-column>
        <!-- <dxi-column dataField="customer.email" caption="Email" width="175"></dxi-column> -->
        <dxi-data-grid-column dataField="displayServiceAddress" caption="Service Address"></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'iconTemplate'" class="d-flex">
          @if (cell.data.showCreditCard) {
            <i class="fa fa-cc-visa" aria-hidden="true"></i>
          }
          @if (cell.data.showEmail) {
            <i class="fa fa-envelope" aria-hidden="true"></i>
          }
          @if (cell.data.showHome) {
            <i class="fa fa-home" aria-hidden="true"></i>
          }
          @if (cell.data.readyToExport) {
            <i class="fa fa-arrow-right green-readyToExport ms-1" aria-hidden="true"></i>
          }
          @if (cell.data.readyToExport && cell.data.quickBooksLastExport) {
            <i class="fa fa-check-square-o green-exported ms-1" aria-hidden="true"></i>
          }
        </div>

        <div *dxTemplate="let cell of 'rentalLinkTemplate'">
          @if (cell && isInvoiceAdmin) {
            <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isInvoiceAdmin) {
            <div [innerHtml]="cell.text"></div>
          }

        </div>


        <div *dxTemplate="let cell of 'customerLinkTemplate'">
          @if (cell && isInvoiceAdmin) {
            <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isInvoiceAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
        <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-sorting [mode]="'multiple'"></dxo-data-grid-sorting>
        <dxo-data-grid-state-storing
          [enabled]="true"
          type="localStorage"
          storageKey="{{ customerId ? 'customer-' : '' }}invoice-overview-grid"
        ></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!showAsComponent) {
            <span>
              <button
                class="btn btn-sm btn-primary me-1 mb-2"
                (click)="open(overviewGrid.instance.getSelectedRowsData()[0])"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                [hidden]="!isInvoiceAdmin"
                >
                Open
              </button>
              <button class="btn btn-sm btn-success me-2 mb-2" (click)="open()" [hidden]="!isInvoiceAdmin">Add</button>
              <button
                class="btn btn-sm btn-danger me-2 mb-2"
                (click)="delete(overviewGrid.instance.getSelectedRowsData()[0])"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                [hidden]="!isInvoiceAdmin"
                >
                Delete
              </button>
              <button
                class="btn btn-sm btn-success me-1 mb-2"
                (click)="sendForReview(overviewGrid.instance.getSelectedRowsData())"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isInvoiceAdmin"
                >
                Send For Review
              </button>
              <button
                class="btn btn-sm btn-success me-1 mb-2"
                (click)="receivePayment()"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isInvoiceAdmin"
                >
                Receive Payment
              </button>
              @if (!false) {
                <dx-drop-down-button
                  class="print-email-dx-button"
                  text="Print/Email"
                  [useSelectMode]="false"
                  [items]="['Print', 'Email', 'Send To']"
                  [dropDownOptions]="{ width: 150 }"
                  [disabled]="false"
                  (onItemClick)="printEmailButtonClick($event)"
                  [hidden]="!isInvoiceAdmin"
                ></dx-drop-down-button>
              }
              <button
                class="btn btn-sm btn-success me-1 mb-2"
                (click)="readyForExport()"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isInvoiceAdmin"
                >
                Ready To Export
              </button>
              <!-- <button class="btn btn-sm btn-warning mb-2" (click)="toggleShowAll()" [hidden]="!isInvoiceAdmin">
              {{ showAll ? 'Show Compact' : 'Show All' }}
            </button> -->
          </span>
        }
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (invoices) {
          <span class="me-3">
            <strong>{{ overviewGrid.instance.totalCount() + ' items' }}</strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
</div>
